export default {
  applicantName: null,
  email: null,
  referralSource: null,
  officePhone: null,
  phone: null,
  mailingAddress: null
};
